export default {
    projectBalanceList: [],
    loading: false
}



// WEBPACK FOOTER //
// ./src/modules/project-balance/state.js